{
  "cultural_ethnic_groups": {
    "ascceg-code.australian": "Australian",
    "ascceg-code.australian_aboriginal": "Australian Aboriginal",
    "ascceg-code.australian_south_sea_islander": "Australian South Sea Islander",
    "ascceg-code.torres_strait_islander": "Torres Strait Islander",
    "ascceg-code.norfolk_islander": "Norfolk Islander",
    "ascceg-code.maori": "Maori",
    "ascceg-code.new_zealander": "New Zealander",
    "ascceg-code.new_caledonian": "New Caledonian",
    "ascceg-code.ni-vanuatu": "Ni-Vanuatu",
    "ascceg-code.papua_new_guinean": "Papua New Guinean",
    "ascceg-code.solomon_islander": "Solomon Islander",
    "ascceg-code.melanesian_and_papuan_nec": "Melanesian and Papuan, nec",
    "ascceg-code.i-kiribati": "I-Kiribati",
    "ascceg-code.nauruan": "Nauruan",
    "ascceg-code.micronesian_nec": "Micronesian, nec",
    "ascceg-code.cook_islander": "Cook Islander",
    "ascceg-code.fijian": "Fijian",
    "ascceg-code.niuean": "Niuean",
    "ascceg-code.samoan": "Samoan",
    "ascceg-code.tongan": "Tongan",
    "ascceg-code.hawaiian": "Hawaiian",
    "ascceg-code.tahitian": "Tahitian",
    "ascceg-code.tokelauan": "Tokelauan",
    "ascceg-code.tuvaluan": "Tuvaluan",
    "ascceg-code.pitcairn": "Pitcairn",
    "ascceg-code.polynesian_nec": "Polynesian, nec",
    "ascceg-code.english": "English",
    "ascceg-code.scottish": "Scottish",
    "ascceg-code.welsh": "Welsh",
    "ascceg-code.channel_islander": "Channel Islander",
    "ascceg-code.manx": "Manx",
    "ascceg-code.british_nec": "British, nec",
    "ascceg-code.irish": "Irish",
    "ascceg-code.austrian": "Austrian",
    "ascceg-code.dutch": "Dutch",
    "ascceg-code.flemish": "Flemish",
    "ascceg-code.french": "French",
    "ascceg-code.german": "German",
    "ascceg-code.swiss": "Swiss",
    "ascceg-code.belgian": "Belgian",
    "ascceg-code.frisian": "Frisian",
    "ascceg-code.luxembourg": "Luxembourg",
    "ascceg-code.western_european_nec": "Western European, nec",
    "ascceg-code.danish": "Danish",
    "ascceg-code.finnish": "Finnish",
    "ascceg-code.icelandic": "Icelandic",
    "ascceg-code.norwegian": "Norwegian",
    "ascceg-code.swedish": "Swedish",
    "ascceg-code.northern_european_nec": "Northern European, nec",
    "ascceg-code.basque": "Basque",
    "ascceg-code.catalan": "Catalan",
    "ascceg-code.italian": "Italian",
    "ascceg-code.maltese": "Maltese",
    "ascceg-code.portuguese": "Portuguese",
    "ascceg-code.spanish": "Spanish",
    "ascceg-code.gibraltarian": "Gibraltarian",
    "ascceg-code.southern_european_nec": "Southern European, nec",
    "ascceg-code.albanian": "Albanian",
    "ascceg-code.bosnian": "Bosnian",
    "ascceg-code.bulgarian": "Bulgarian",
    "ascceg-code.croatian": "Croatian",
    "ascceg-code.greek": "Greek",
    "ascceg-code.macedonian": "Macedonian",
    "ascceg-code.moldovan": "Moldovan",
    "ascceg-code.montenegrin": "Montenegrin",
    "ascceg-code.romanian": "Romanian",
    "ascceg-code.roma_gypsy": "Roma Gypsy",
    "ascceg-code.serbian": "Serbian",
    "ascceg-code.slovene": "Slovene",
    "ascceg-code.cypriot": "Cypriot",
    "ascceg-code.vlach": "Vlach",
    "ascceg-code.south_eastern_european_nec": "South Eastern European, nec",
    "ascceg-code.belarusan": "Belarusan",
    "ascceg-code.czech": "Czech",
    "ascceg-code.estonian": "Estonian",
    "ascceg-code.hungarian": "Hungarian",
    "ascceg-code.latvian": "Latvian",
    "ascceg-code.lithuanian": "Lithuanian",
    "ascceg-code.polish": "Polish",
    "ascceg-code.russian": "Russian",
    "ascceg-code.slovak": "Slovak",
    "ascceg-code.ukrainian": "Ukrainian",
    "ascceg-code.sorb_wend": "Sorb/Wend",
    "ascceg-code.eastern_european_nec": "Eastern European, nec",
    "ascceg-code.algerian": "Algerian",
    "ascceg-code.egyptian": "Egyptian",
    "ascceg-code.iraqi": "Iraqi",
    "ascceg-code.jordanian": "Jordanian",
    "ascceg-code.kuwaiti": "Kuwaiti",
    "ascceg-code.lebanese": "Lebanese",
    "ascceg-code.libyan": "Libyan",
    "ascceg-code.moroccan": "Moroccan",
    "ascceg-code.palestinian": "Palestinian",
    "ascceg-code.saudi_arabian": "Saudi Arabian",
    "ascceg-code.syrian": "Syrian",
    "ascceg-code.tunisian": "Tunisian",
    "ascceg-code.yemeni": "Yemeni",
    "ascceg-code.bahraini": "Bahraini",
    "ascceg-code.emirati": "Emirati",
    "ascceg-code.omani": "Omani",
    "ascceg-code.qatari": "Qatari",
    "ascceg-code.arab_nec": "Arab, nec",
    "ascceg-code.jewish": "Jewish",
    "ascceg-code.bari": "Bari",
    "ascceg-code.darfur": "Darfur",
    "ascceg-code.dinka": "Dinka",
    "ascceg-code.nuer": "Nuer",
    "ascceg-code.south_sudanese": "South Sudanese",
    "ascceg-code.sudanese": "Sudanese",
    "ascceg-code.peoples_of_the_sudan_nec": "Peoples of the Sudan, nec",
    "ascceg-code.berber": "Berber",
    "ascceg-code.coptic": "Coptic",
    "ascceg-code.iranian": "Iranian",
    "ascceg-code.kurdish": "Kurdish",
    "ascceg-code.turkish": "Turkish",
    "ascceg-code.assyrian": "Assyrian",
    "ascceg-code.chaldean": "Chaldean",
    "ascceg-code.mandaean": "Mandaean",
    "ascceg-code.nubian": "Nubian",
    "ascceg-code.yezidi": "Yezidi",
    "ascceg-code.other_north_african_and_middle_eastern_nec": "Other North African and Middle Eastern, nec",
    "ascceg-code.anglo-burmese": "Anglo-Burmese",
    "ascceg-code.burmese": "Burmese",
    "ascceg-code.hmong": "Hmong",
    "ascceg-code.khmer_cambodian": "Khmer (Cambodian)",
    "ascceg-code.lao": "Lao",
    "ascceg-code.thai": "Thai",
    "ascceg-code.vietnamese": "Vietnamese",
    "ascceg-code.karen": "Karen",
    "ascceg-code.mon": "Mon",
    "ascceg-code.chin": "Chin",
    "ascceg-code.rohingya": "Rohingya",
    "ascceg-code.mainland_south-east_asian_nec": "Mainland South-East Asian, nec",
    "ascceg-code.filipino": "Filipino",
    "ascceg-code.indonesian": "Indonesian",
    "ascceg-code.javanese": "Javanese",
    "ascceg-code.madurese": "Madurese",
    "ascceg-code.malay": "Malay",
    "ascceg-code.sundanese": "Sundanese",
    "ascceg-code.timorese": "Timorese",
    "ascceg-code.acehnese": "Acehnese",
    "ascceg-code.balinese": "Balinese",
    "ascceg-code.bruneian": "Bruneian",
    "ascceg-code.kadazan": "Kadazan",
    "ascceg-code.singaporean": "Singaporean",
    "ascceg-code.temoq": "Temoq",
    "ascceg-code.maritime_south-east_asian_nec": "Maritime South-East Asian, nec",
    "ascceg-code.chinese": "Chinese",
    "ascceg-code.taiwanese": "Taiwanese",
    "ascceg-code.chinese_asian_nec": "Chinese Asian, nec",
    "ascceg-code.japanese": "Japanese",
    "ascceg-code.korean": "Korean",
    "ascceg-code.mongolian": "Mongolian",
    "ascceg-code.tibetan": "Tibetan",
    "ascceg-code.other_north-east_asian_nec": "Other North-East Asian, nec",
    "ascceg-code.anglo-indian": "Anglo-Indian",
    "ascceg-code.bengali": "Bengali",
    "ascceg-code.burgher": "Burgher",
    "ascceg-code.gujarati": "Gujarati",
    "ascceg-code.indian": "Indian",
    "ascceg-code.malayali": "Malayali",
    "ascceg-code.nepalese": "Nepalese",
    "ascceg-code.pakistani": "Pakistani",
    "ascceg-code.punjabi": "Punjabi",
    "ascceg-code.sikh": "Sikh",
    "ascceg-code.sinhalese": "Sinhalese",
    "ascceg-code.maldivian": "Maldivian",
    "ascceg-code.bangladeshi": "Bangladeshi",
    "ascceg-code.bhutanese": "Bhutanese",
    "ascceg-code.fijian_indian": "Fijian Indian",
    "ascceg-code.kashmiri": "Kashmiri",
    "ascceg-code.parsi": "Parsi",
    "ascceg-code.sindhi": "Sindhi",
    "ascceg-code.sri_lankan": "Sri Lankan",
    "ascceg-code.sri_lankan_tamil": "Sri Lankan Tamil",
    "ascceg-code.indian_tamil": "Indian Tamil",
    "ascceg-code.tamil_nfd": "Tamil, nfd",
    "ascceg-code.telugu": "Telugu",
    "ascceg-code.southern_asian_nec": "Southern Asian, nec",
    "ascceg-code.afghan": "Afghan",
    "ascceg-code.armenian": "Armenian",
    "ascceg-code.georgian": "Georgian",
    "ascceg-code.kazakh": "Kazakh",
    "ascceg-code.pathan": "Pathan",
    "ascceg-code.uzbek": "Uzbek",
    "ascceg-code.azeri": "Azeri",
    "ascceg-code.hazara": "Hazara",
    "ascceg-code.tajik": "Tajik",
    "ascceg-code.tatar": "Tatar",
    "ascceg-code.turkmen": "Turkmen",
    "ascceg-code.uighur": "Uighur",
    "ascceg-code.kyrgyz": "Kyrgyz",
    "ascceg-code.central_asian_nec": "Central Asian, nec",
    "ascceg-code.african_american": "African American",
    "ascceg-code.american": "American",
    "ascceg-code.canadian": "Canadian",
    "ascceg-code.french_canadian": "French Canadian",
    "ascceg-code.hispanic_north_american": "Hispanic North American",
    "ascceg-code.native_north_american_indian": "Native North American Indian",
    "ascceg-code.bermudan": "Bermudan",
    "ascceg-code.north_american_nec": "North American, nec",
    "ascceg-code.argentinian": "Argentinian",
    "ascceg-code.bolivian": "Bolivian",
    "ascceg-code.brazilian": "Brazilian",
    "ascceg-code.chilean": "Chilean",
    "ascceg-code.colombian": "Colombian",
    "ascceg-code.ecuadorian": "Ecuadorian",
    "ascceg-code.guyanese": "Guyanese",
    "ascceg-code.peruvian": "Peruvian",
    "ascceg-code.uruguayan": "Uruguayan",
    "ascceg-code.venezuelan": "Venezuelan",
    "ascceg-code.paraguayan": "Paraguayan",
    "ascceg-code.south_american_nec": "South American, nec",
    "ascceg-code.mexican": "Mexican",
    "ascceg-code.nicaraguan": "Nicaraguan",
    "ascceg-code.salvadoran": "Salvadoran",
    "ascceg-code.costa_rican": "Costa Rican",
    "ascceg-code.guatemalan": "Guatemalan",
    "ascceg-code.mayan": "Mayan",
    "ascceg-code.central_american_nec": "Central American, nec",
    "ascceg-code.cuban": "Cuban",
    "ascceg-code.jamaican": "Jamaican",
    "ascceg-code.trinidadian_tobagonian": "Trinidadian Tobagonian",
    "ascceg-code.barbadian": "Barbadian",
    "ascceg-code.puerto_rican": "Puerto Rican",
    "ascceg-code.caribbean_islander_nec": "Caribbean Islander, nec",
    "ascceg-code.akan": "Akan",
    "ascceg-code.fulani": "Fulani",
    "ascceg-code.ghanaian": "Ghanaian",
    "ascceg-code.nigerian": "Nigerian",
    "ascceg-code.yoruba": "Yoruba",
    "ascceg-code.ivorean": "Ivorean",
    "ascceg-code.liberian": "Liberian",
    "ascceg-code.sierra_leonean": "Sierra Leonean",
    "ascceg-code.acholi": "Acholi",
    "ascceg-code.cameroonian": "Cameroonian",
    "ascceg-code.congolese": "Congolese",
    "ascceg-code.gio": "Gio",
    "ascceg-code.igbo": "Igbo",
    "ascceg-code.krahn": "Krahn",
    "ascceg-code.mandinka": "Mandinka",
    "ascceg-code.senegalese": "Senegalese",
    "ascceg-code.themne": "Themne",
    "ascceg-code.togolese": "Togolese",
    "ascceg-code.central_and_west_african_nec": "Central and West African, nec",
    "ascceg-code.afrikaner": "Afrikaner",
    "ascceg-code.angolan": "Angolan",
    "ascceg-code.eritrean": "Eritrean",
    "ascceg-code.ethiopian": "Ethiopian",
    "ascceg-code.kenyan": "Kenyan",
    "ascceg-code.malawian": "Malawian",
    "ascceg-code.mauritian": "Mauritian",
    "ascceg-code.mozambican": "Mozambican",
    "ascceg-code.namibian": "Namibian",
    "ascceg-code.oromo": "Oromo",
    "ascceg-code.seychellois": "Seychellois",
    "ascceg-code.somali": "Somali",
    "ascceg-code.south_african": "South African",
    "ascceg-code.tanzanian": "Tanzanian",
    "ascceg-code.ugandan": "Ugandan",
    "ascceg-code.zambian": "Zambian",
    "ascceg-code.zimbabwean": "Zimbabwean",
    "ascceg-code.amhara": "Amhara",
    "ascceg-code.batswana": "Batswana",
    "ascceg-code.hutu": "Hutu",
    "ascceg-code.masai": "Masai",
    "ascceg-code.tigrayan": "Tigrayan",
    "ascceg-code.tigre": "Tigre",
    "ascceg-code.zulu": "Zulu",
    "ascceg-code.burundian": "Burundian",
    "ascceg-code.kunama": "Kunama",
    "ascceg-code.madi": "Madi",
    "ascceg-code.ogaden": "Ogaden",
    "ascceg-code.rwandan": "Rwandan",
    "ascceg-code.shona": "Shona",
    "ascceg-code.swahili": "Swahili",
    "ascceg-code.swazilander": "Swazilander",
    "ascceg-code.southern_and_east_african_nec": "Southern and East African, nec"
  }
}
